import { useState } from "react";
import AnimatedArrow from "./AnimatedArrow";

export default function AppOverview({
  icon = "",
  name = "",
  subtitle = "",
  description = "",
  appstore = "",
  url = "",
  screenshots = [],
}) {
  const [borderRadii, setBorderRadii] = useState({});

  const handleImageLoad = (index, event) => {
    const width = event.target.offsetWidth;
    const borderRadius = width * 0.14;
    setBorderRadii((prev) => ({
      ...prev,
      [index]: `${borderRadius}px`,
    }));
  };

  return (
    <div className="flex basis-5/12 bg-white border flex-col divide-y divide-x-0 md:flex-row md:divide-y-0 md:divide-x">
      <div className="flex flex-1 flex-col divide-y">
        <div className="flex flex-row gap-4 items-center p-4 lg:p-8">
          <img src={icon} alt="icon" className="h-16 bg-red-300 rounded-xl" />
          <div className="text-left">
            <h3 className="text-2xl">{name}</h3>
            <p className="opacity-50">{subtitle}</p>
          </div>
        </div>
        <div className="gap-8 flex flex-col flex-1 justify-between p-4 lg:p-8">
          <div className="text-left">
            <div>{description}</div>
          </div>
          <div className="flex flex-col md:flex-row gap-4 md:items-end">
            <a
              href={appstore}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer"
            >
              <img
                className="h-14"
                alt="appstore"
                src={require("../assets/icons/appstore_badge.webp")}
              />
            </a>
            {url && (
              <a
                href={"https://" + url}
                target="_blank"
                rel="noopener noreferrer"
                className="group gap-1 cursor-pointer flex items-center opacity-50 hover:opacity-30"
              >
                <p className="underline underline-offset-2 font-mono text-sm">
                  {url}
                </p>
                <AnimatedArrow color="black" />
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="flex basis-7/12  gap-4 overflow-scroll no-scrollbar p-4 lg:p-8">
        {screenshots?.length > 0 &&
          screenshots.map((screen, index) => (
            <div key={index} className="shrink-0">
              <img
                className="h-[520px] w-auto object-contain"
                style={{
                  borderRadius: borderRadii[index] || "0px",
                }}
                alt="screenshot"
                src={screen}
                onLoad={(e) => handleImageLoad(index, e)}
              />
            </div>
          ))}
      </div>
    </div>
  );
}
